import { IconDefinition } from '../../types';

const MinusLight: IconDefinition = {
  name: 'minus-light',
  definition: {
    viewBox: '0 0 384 512',
    pathData:
      'M376 232H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h368c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z'
  }
};

export default MinusLight;
